import logger from './logger';

const SAFE_FIELDS = ['_id', 'id', 'userId', 'name', 'role', 'firstName', 'lastName', 'profilePicture', 'username', 'handle']; // only non-sensitive identifiers

const sanitizeUser = (user) => {
  if (!user || typeof user !== 'object') return null;
  const safe = {};
  SAFE_FIELDS.forEach((f) => { if (user[f] !== undefined) safe[f] = user[f]; });
  return safe;
};

export const setUserToStorage = (user) => {
  if (user) {
    try {
      const safeUser = sanitizeUser(user);
      localStorage.setItem("userData", JSON.stringify(safeUser));
      localStorage.setItem("isAuthenticated", "true");
    } catch (error) {
      logger.error("Error saving to localStorage:", error);
    }
  }
};


export const getUseFromStorage = () => {
  try {
    const data = localStorage.getItem("userData");
    if (!data || data === "undefined" || data === "null") return null;
    return JSON.parse(data);
  } catch (error) {
    logger.error("Error parsing userData:", error);
    localStorage.removeItem("userData"); // cleanup invalid entry
    return null;
  }
};


export const getAuthStatusFromStorage = () => {
  return localStorage.getItem("isAuthenticated") === "true";
};


export const clearUserFromStorage = () => {
  localStorage.removeItem("userData");
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("serviceProviderEnabled");
};


// ── Service Provider Enabled Flag ─────────────────────────────────────────────
// Stored at login/auth time by the backend to indicate the user has services.
// Used as a fast fallback in ProtectedRoute while Redux data is still loading.

export const setServiceProviderEnabled = (enabled) => {
  try {
    localStorage.setItem("serviceProviderEnabled", enabled ? "true" : "false");
  } catch (error) {
    logger.error("Error saving serviceProviderEnabled:", error);
  }
};

export const getServiceProviderEnabled = () => {
  return localStorage.getItem("serviceProviderEnabled") === "true";
};
